module.exports = __webpack_public_path__ + "img/logo.31fd835b.png";